import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdtContract, tomiContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const ApproveTomi = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tomi;
  const tokenAddress1 = Environment.presaleContract;
  const contract = tomiContract(tokenAddress, web3);

  const approveTomi = useCallback(
    async (amount) => {
      try {
        let nd = web3.utils.toWei(amount.toString(), "ether");
        // let gasPrice = await web3.eth.getGasPrice();
        // gasPrice = parseInt(gasPrice) + 5000000000;
        const gas = await contract.methods
          .approve(tokenAddress1, nd)
          .estimateGas({ from: account });
        // let gasPrice = await web3.eth.getGasPrice();
        const details = await contract.methods.approve(tokenAddress1, nd).send({
          from: account,
          gas: gas,
          // gasPrice,
        });
        return details;
        // console.log('sdsdss' ,  buy)
        // return details;
      } catch (error) {
        throw error;
      }
    },
    [contract, account, web3]
  );
  return { approveTomi: approveTomi };
};
export default ApproveTomi;
